import React, { useState, useEffect } from 'react'
import { useAuth } from '../contexts/AuthContext'

interface Event {
  id: number
  slug: string
  title: string
  venue: string
  start_at: string
  end_at: string
  status: string
}

const AdminPage: React.FC = () => {
  const { user } = useAuth()
  const [events, setEvents] = useState<Event[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    if (user?.roles.includes('admin')) {
      fetchEvents()
    }
  }, [user])

  const fetchEvents = async () => {
    try {
      const response = await fetch('/api/admin/events', {
        credentials: 'include',
      })
      
      if (!response.ok) {
        throw new Error('Failed to fetch events')
      }
      
      const data = await response.json()
      setEvents(data)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch events')
    } finally {
      setLoading(false)
    }
  }

  if (!user?.roles.includes('admin')) {
    return (
      <div className="card">
        <div className="alert alert-error">
          Access denied. Admin privileges required.
        </div>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="text-center">
        <span className="spinner" />
        <p>Loading events...</p>
      </div>
    )
  }

  return (
    <div>
      <div className="mb-8">
        <h1>Event Management</h1>
        <p>Create and manage ASF events for child registration.</p>
      </div>

      {error && (
        <div className="alert alert-error mb-4">
          {error}
        </div>
      )}

      <div className="card mb-8">
        <h2 className="mb-4">Create New Event</h2>
        <p className="text-gray-600">
          Event creation form will be implemented here.
        </p>
        <button className="btn btn-primary mt-4">
          Create Event
        </button>
      </div>

      <div className="card">
        <h2 className="mb-4">Active Events</h2>
        {events.length === 0 ? (
          <p className="text-gray-600">No events found.</p>
        ) : (
          <div className="space-y-4">
            {events.map((event) => (
              <div key={event.id} className="border rounded p-4">
                <h3 className="font-semibold">{event.title}</h3>
                <p className="text-sm text-gray-600">
                  {event.venue} • {new Date(event.start_at).toLocaleDateString()}
                </p>
                <p className="text-sm">
                  Status: <span className="font-medium">{event.status}</span>
                </p>
                <div className="mt-2">
                  <button className="btn btn-secondary btn-sm mr-2">
                    Edit
                  </button>
                  <button className="btn btn-danger btn-sm">
                    Delete
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default AdminPage
